import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/navbar';
import Footer from '../../../../components/footer';
import Button from '../../../../components/Button';
import Dropdown from '../../../../components/Dropdown';
import { useConsultation } from '../../../../context/ConsultationContext';
import { handleTreatmentServiceNavigation } from '../components/treatmentNavigationHelper';
import styles from './css/BloodPressure.module.css';
import newStyles from './css/FamilyPlanning.module.css';
import { Users, Send } from 'lucide-react';

const FamilyPlanning = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { consultationData, updateConsultationData, getStepDraft, setStepDraft, goToStep } = useConsultation();

    const patient = location?.state?.patient || consultationData?.patient || {};
    const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim() || "Thandiwe Ndlovu";
    const profileNumber = patient?.profilenumber || "448896";
    const initials = `${patient?.firstname?.[0] || ""}${patient?.surname?.[0] || ""}`.toUpperCase() || "TN";

    // Load consent form data if returning from consent form
    const consentData = getStepDraft?.('consentForms', {})?.family_planning?.answers || {};
    const returnedFromConsent = location?.state?.returnedFromConsent;

    // Family planning states
    const [currentContraception, setCurrentContraception] = useState(consentData?.currentContraception || '');
    const [pregnancyRisk, setPregnancyRisk] = useState(consentData?.pregnancyRisk || '');
    const [methodProvided, setMethodProvided] = useState(consentData?.methodProvided || '');
    const [clinicalNotes, setClinicalNotes] = useState(consentData?.clinicalNotes || '');

    const handleInvoice = () => {
        handleTreatmentServiceNavigation({
            location,
            navigate,
            consultationData,
            updateConsultationData,
            getStepDraft,
            setStepDraft,
            goToStep,
            serviceData: {
                family_planning: {
                    currentContraception,
                    pregnancyRisk,
                    methodProvided,
                    clinicalNotes,
                },
            },
        });
    };

    useEffect(() => {
        document.body.classList.add(styles.hideSidebar);
        return () => {
            document.body.classList.remove(styles.hideSidebar);
        };
    }, []);

    return (
        <div className={styles.bloodPressureContainer}>
            <Navbar />

            <main className={styles.mainContent}>
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.headerIcon} aria-hidden="true">
                            <Users />
                        </div>
                        <h1 className={newStyles.title}>Family Planning</h1>
                    </div>

                    <div className={styles.patientCard}>
                        <div className={styles.avatar} aria-hidden="true">{initials}</div>
                        <div className={styles.patientText}>
                            <div className={styles.patientName}>{patientName}</div>
                            <div className={styles.patientMetaRow}>
                                <span className={styles.profileInfo}>Profile: {profileNumber}</span>
                                <span className={styles.dependentBadge}>Dependent</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>CONTRACEPTION DETAILS</div>
                        <div className={newStyles.readingsRow}>
                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Current Contraception</label>
                                <div className={styles.inputGroup}>
                                    <Dropdown
                                        name="currentContraception"
                                        value={currentContraception}
                                        onChange={setCurrentContraception}
                                        options={['None', 'Oral Contraceptives', 'IUD', 'Condoms', 'Injectables', 'Implants', 'Natural Methods']}
                                        placeholder="Select..."
                                        className={newStyles.readingInput}
                                        alignLeft
                                    />
                                </div>
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Pregnacy Risk</label>
                                <div className={styles.inputGroup}>
                                    <Dropdown
                                        name="pregnancyRisk"
                                        value={pregnancyRisk}
                                        onChange={setPregnancyRisk}
                                        options={['Low', 'Medium', 'High']}
                                        placeholder="Select..."
                                        className={newStyles.readingInput}
                                        alignLeft
                                    />
                                </div>
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Method Provided</label>
                                <div className={styles.inputGroup}>
                                    <Dropdown
                                        name="methodProvided"
                                        value={methodProvided}
                                        onChange={setMethodProvided}
                                        options={['None', 'Oral Contraceptives', 'IUD', 'Condoms', 'Injectables', 'Implants', 'Emergency Contraception']}
                                        placeholder="Select..."
                                        className={newStyles.readingInput}
                                        alignLeft
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.fieldLabel}>Clinical Notes</div>
                        <textarea
                            value={clinicalNotes}
                            onChange={(e) => setClinicalNotes(e.target.value)}
                            className={styles.clinicalNotes}
                            placeholder="Enter clinical notes..."
                            rows={6}
                        />
                    </div>

                    <div className={styles.cardFooter}>
                        <Button
                            onClick={handleInvoice}
                            className={styles.invoiceButton}
                            type="button"
                        >
                            <Send size={16} />
                            Invoice
                        </Button>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default FamilyPlanning;